import { render, staticRenderFns } from "./Reccomdationanddiagonis.vue?vue&type=template&id=4b273caf&scoped=true&"
import script from "./Reccomdationanddiagonis.vue?vue&type=script&lang=js&"
export * from "./Reccomdationanddiagonis.vue?vue&type=script&lang=js&"
import style0 from "./Reccomdationanddiagonis.vue?vue&type=style&index=0&id=4b273caf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b273caf",
  null
  
)

export default component.exports